import script from "./AudioPlayerControlBar.vue?vue&type=script&setup=true&lang=js"
export * from "./AudioPlayerControlBar.vue?vue&type=script&setup=true&lang=js"

import "./AudioPlayerControlBar.vue?vue&type=style&index=0&id=10284709&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10284709"]])

export default __exports__